import { render, staticRenderFns } from "./Amaechi.vue?vue&type=template&id=09640713&scoped=true&"
import script from "./Amaechi.vue?vue&type=script&lang=js&"
export * from "./Amaechi.vue?vue&type=script&lang=js&"
import style0 from "./Amaechi.vue?vue&type=style&index=0&id=09640713&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09640713",
  null
  
)

export default component.exports